import { find, cloneDeep, omit } from 'lodash-es';
import { PSO } from '@mummssoftware/utils/constants';
import { DISNO, WA } from '@mummssoftware/utils/orders';
import { mapTag, order, OLD_PCPP } from '../../Context/constants';
import { ProgressNotesPSOData } from '../../Context/ProgressNotesContext';

export const hasPatientApproval = (
  patientApprovals: mumms.Approval[],
  note: mumms.progressNote | mumms.progressNotebyEntity,
) =>
  patientApprovals && patientApprovals.length
    ? find(
        patientApprovals,
        (x: mumms.Approval) => x.entityid === note?.id.toString(),
      )
    : null;

export const getTagMap = (
  note: mumms.progressNotebyEntity | mumms.progressNote,
  patientApprovals: mumms.Approval[],
) => {
  const patientDTO = note.patientprogressnoteentitydto;
  let patientDTOFiltered: any = cloneDeep(patientDTO);

  if (patientDTO && (patientDTO as any)[OLD_PCPP]) {
    patientDTOFiltered = omit(patientDTOFiltered, OLD_PCPP);
  }
  if (patientDTO && (patientDTO as any)[DISNO]) {
    patientDTOFiltered = omit(patientDTOFiltered, DISNO);
  }

  if (patientDTOFiltered) {
    const hasApprovals = hasPatientApproval(patientApprovals, note);

    const hasWrittenApproval = !!(
      hasApprovals && hasApprovals.approvalstatusshortname === WA
    );
    const tagMap = Object.keys(patientDTOFiltered).reduce(
      (seed: any, val: any) => {
        seed[mapTag[val]] = {
          type: mapTag[val] as mumms.TagType,
          info: patientDTOFiltered[val],
          success: hasWrittenApproval,
          // success: mapTag[val] === order ? hasWrittenApproval : null,
        };
        return seed;
      },
      {},
    );
    if (tagMap[PSO] && !tagMap.order) {
      tagMap.order = {
        type: order,
        success: hasWrittenApproval,
      };
    }
    return tagMap;
  }
  return null;
};

export const getPsoWithSameEntityKey = (
  ordersGlobalMapEffectiveDate: ProgressNotesPSOData[] | null | undefined,
  noteInfoId: number,
) =>
  ordersGlobalMapEffectiveDate &&
  ordersGlobalMapEffectiveDate.find(
    (pso: any) => Number(Object.keys(pso)[0]) === noteInfoId,
  );
